import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import {User} from '@models/user/user';
import {BrandingService} from '@services/administration/organization/configuration/branding/branding.service';
import {FirebaseAuthenticationService} from '@services/firebase/auth/firebase-authentication.service';
import {AuthenticationRedirectService} from '@services/user/authentication-redirect.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuardService  {

  constructor(private firebaseAuthenticationService: FirebaseAuthenticationService,
              private brandingService: BrandingService,
              private authenticationRedirectService: AuthenticationRedirectService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.authenticationRedirectService.setReturnUrl(state.url);
    return new Observable<boolean>((observer) => {
      this.firebaseAuthenticationService.getLoggedUserDetails().subscribe((user: User) => {
        if (!user) {
          observer.next(false);
          observer.complete();
          return;
        }
        this.authenticationRedirectService.clearReturnUrl();
        const result = this.authorizeUser(route, user);
        this.brandingService.applyOrganizationStyles(user.parentId, false);
        observer.next(result);
        observer.complete();
        return result;
      }, (error: HttpResponse<any>) => {
        if (error?.status !== 401) {
          this.authenticationRedirectService.clearReturnUrl();
        }
        console.error('AuthorizationGuardService. Error getting current user details.', JSON.stringify(error));
        observer.next(false);
        observer.complete();
        return false;
      });
    });
  }

  private authorizeUser(route: ActivatedRouteSnapshot, user: User): boolean {
    // check if route is restricted by role
    if (route.data && route.data.roles) {
      if (user) {
        if (route.data.roles.indexOf(user.role) === -1) {
          // role not authorised
          console.error(`${user.role} role not authorised.`);
          return false;
        }
      } else {
        return false;
      }
    }

    return true;
  }
}
